export default function Footer() {
  return (
    <footer id="footer" className="bg-secondary-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 mb-12">
            <div className="lg:col-span-2">
              <span className="font-heading text-xl font-bold text-background-50">
                木瓜影视
              </span>
              <p className="mt-3 text-sm leading-relaxed text-secondary-300 max-w-md">
                木瓜影视是国内领先的高清电视剧在线观影平台，提供海量电视剧资源免费在线观看。每日更新最新热播剧，极速播放不卡顿不缓冲，无广告纯净追剧体验。涵盖国产剧、韩剧、日剧、美剧等多种类型，是追剧爱好者的首选平台。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                快速导航
              </h4>
              <div className="flex flex-col gap-2">
                <a href="#hero" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">首页</a>
                <a href="#ranking" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">热度榜单</a>
                <a href="#updates" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">最新动态</a>
                <a href="#carousel" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">焦点专题</a>
                <a href="#faq" className="text-sm text-secondary-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">常见问题</a>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                合作伙伴
              </h4>
              <p className="text-sm text-secondary-400 leading-relaxed">
                更多合作伙伴即将入驻，敬请期待。
              </p>
            </div>
          </div>

          <div className="border-t border-secondary-700 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-secondary-400">
              &copy; 2020-2026 木瓜影视 muguays.com 版权所有
            </p>
            <div className="flex items-center gap-6">
              <a href="#hero" className="text-xs text-secondary-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">服务条款</a>
              <a href="#hero" className="text-xs text-secondary-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">隐私政策</a>
              <a href="#contact" className="text-xs text-secondary-400 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">联系我们</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}